import {
  getPackagesV3,
} from '@/api/config';

const config = {
  namespaced: true,
  state: {
    tabs: [],
    loadingFail: false,
  },

  mutations: {
    SET_DATA: (state, obj) => {
      Object.assign(state, obj);
    },

  },

  actions: {
    // config/getConfig
    async getConfig({ commit }, payload) {
      let res;
      try {
        res = await getPackagesV3(payload);
        const {
          tabSort,
        } = res.data;

        const tabs = tabSort;
        commit('SET_DATA', {
          tabs,
          loadingFail: false,
        });
      } catch (e) {
        commit('SET_DATA', {
          tabs: [],
          loadingFail: true,
        });
        throw e;
      }
    },

  },
};

export default config;
